calendars-material_lots
  span.material(each="{item in opts.items}")
    span.name {parent.material_name(item.material_id)}
    span.num.badge.badge-primary(if="{item.num}") {item.num}
    span.texts.badge.badge-primary(if="{item.texts.length > 0}") {item.texts.join(',')}
  script(type="typescript").
    this.mixin('calendars.material_lots');
  style(scoped).
    .material {
      display: inline-block;
      margin-right: 1rem;
    }
    .num,
    .texts {
      display: inline-block;
    }
    .num,
    .texts {
      margin-left: .5rem;
    }
